// extracted by mini-css-extract-plugin
export default {"iconButton":"AppropriatenessTestUploadModal_iconButton__s5TgK","body":"AppropriatenessTestUploadModal_body__CW3Aa"};